// import this after install `@mdi/font` package
import '@mdi/font/css/materialdesignicons.css'
// @mdi/font ships its @font-face without font-display, which blocks text
// rendering until the icon font loads (or times out); override with swap.
import mdiWoff2Url from '@mdi/font/fonts/materialdesignicons-webfont.woff2?url'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { VFileUpload } from 'vuetify/labs/VFileUpload'

export default defineNuxtPlugin((app) => {
  useHead({
    style: [{
      innerHTML: `@font-face{font-family:"Material Design Icons";src:url(${mdiWoff2Url}) format("woff2");font-weight:normal;font-style:normal;font-display:swap;}`,
      tagPriority: 'low'
    }]
  })

  const vuetify = createVuetify({
    ssr: true,
    components: {
      VFileUpload
    },
    defaults: {
      VCard: {
        elevation: 2,
      },
      VSheet: {
        elevation: 2,
      }
    },
  })
  app.vueApp.use(vuetify)
})
